import {  storyblokEditable } from "@storyblok/react";
 
const Page = ({ blok }) => (
  <main {...storyblokEditable(blok)}>
    {console.log({blok})}
  </main>
);
 
export default Page;